export default __webpack_public_path__ + "assets/b2825afbc88e3f05d558f6c0b210bcc8.png";